"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _capitalize = _interopRequireDefault(require("../utils/capitalize"));

var _TypographyModule = _interopRequireDefault(require("./Typography.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Typography = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _clsx;

  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$outline = props.outline,
      outline = _props$outline === void 0 ? false : _props$outline,
      _props$weight = props.weight,
      weight = _props$weight === void 0 ? 'normal' : _props$weight,
      vignette = props.vignette,
      _props$size = props.size,
      size = _props$size === void 0 ? 'base' : _props$size,
      _props$font = props.font,
      font = _props$font === void 0 ? 'body' : _props$font,
      maxWidth = props.maxWidth,
      other = _objectWithoutProperties(props, ["align", "className", "color", "component", "display", "gutterBottom", "noWrap", "outline", "weight", "vignette", "size", "font", "maxWidth"]);

  var Component = component || 'span';
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: (0, _clsx2["default"])(_TypographyModule["default"].text, (_clsx = {}, _defineProperty(_clsx, _TypographyModule["default"]["color".concat((0, _capitalize["default"])(color))], color !== 'initial'), _defineProperty(_clsx, _TypographyModule["default"].noWrap, noWrap), _defineProperty(_clsx, _TypographyModule["default"].gutterBottom, gutterBottom), _defineProperty(_clsx, _TypographyModule["default"]["align".concat((0, _capitalize["default"])(align))], align !== 'inherit'), _defineProperty(_clsx, _TypographyModule["default"]["display".concat((0, _capitalize["default"])(display))], display !== 'initial'), _defineProperty(_clsx, _TypographyModule["default"]["text".concat((0, _capitalize["default"])(weight))], weight !== 'normal'), _defineProperty(_clsx, _TypographyModule["default"].outline, outline), _defineProperty(_clsx, _TypographyModule["default"]["size".concat((0, _capitalize["default"])(size))], size !== 'base'), _defineProperty(_clsx, _TypographyModule["default"]["font".concat((0, _capitalize["default"])(font))], font !== 'body'), _clsx), className),
    style: {
      maxWidth: maxWidth
    },
    ref: ref
  }, other));
});
Typography.displayName = 'Typography';
var _default = Typography;
exports["default"] = _default;